/**
 * Identifiers.
 *
 * The prototype used `Math.random().toString(36).slice(2, 10)` — 8 characters,
 * ~2.8e12 of entropy, and a real collision risk once contacts and moves share
 * an id space across accounts. Everything created from here on is a UUID v4.
 */

/** A fresh id for any row we create. */
export function createId(): string {
  return crypto.randomUUID();
}

/** True for ids minted by the legacy prototype (8 chars of [0-9a-z]). */
export function isLegacyId(id: string): boolean {
  return /^[0-9a-z]{1,10}$/.test(id) && !id.includes("-");
}
